import React, { createContext, useContext } from 'react';

interface InterviewTimerContextType {
  time: string;
  totalSeconds: number;
  progressPercentage: number;
}

const InterviewTimerContext = createContext<InterviewTimerContextType>({
  time: '00:00:00',
  totalSeconds: 0,
  progressPercentage: 0,
});

export const useInterviewTimer = () => useContext(InterviewTimerContext);

export const InterviewTimerProvider: React.FC<{
  children: React.ReactNode;
  time: string;
  totalSeconds: number;
  progressPercentage: number;
}> = ({ children, time, totalSeconds, progressPercentage }) => {
  return (
    <InterviewTimerContext.Provider value={{ time, totalSeconds, progressPercentage }}>
      {children}
    </InterviewTimerContext.Provider>
  );
};
